import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CardComponent } from '../card/card.component';
import { CardMessageComponent } from '../card-message/card-message.component';
import { CardModel, CardState } from '../games/models/game-view.model';
import { ResultChange } from '../result-change/result-change.service';

@Component({
    selector: 'app-card-holder',
    standalone: true,
    imports: [CommonModule, CardComponent, CardMessageComponent],
    templateUrl: './card-holder.component.html',
    styleUrl: './card-holder.component.scss'
})
export class CardHolderComponent {
    @Input()
    card!: CardModel;

    protected readonly CardState = CardState;

    constructor(protected readonly resultChange: ResultChange) {}

    protected selectCard(card: CardModel): void {
        this.resultChange.selectCard(card);
    }

    protected revertCardValue(card: CardModel): void {
        this.resultChange.revert(card);
    }
}
